import { render } from "./ThumbCard.vue?vue&type=template&id=7fd9dd27"
import script from "./ThumbCard.vue?vue&type=script&lang=js"
export * from "./ThumbCard.vue?vue&type=script&lang=js"

import "./ThumbCard.vue?vue&type=style&index=0&id=7fd9dd27&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__